export default {
    uppercasefirst: (value) => {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0) + value.slice(1).toLowerCase()
    }
}

